import React, { useState, useEffect } from 'react';
import DashLayout from '../componets/layout/DashLayout';
import Preloader from '../componets/layout/preloader';
import './users.css';
import { supabase } from '../supabaseClient';

const Users = () => {
    const [modalOpen, setModalOpen] = useState(false);
    const [editModalOpen, setEditModalOpen] = useState(false);
    const [editItem, setEditItem] = useState(null);
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [filterRole, setFilterRole] = useState('');
    const [filterStatus, setFilterStatus] = useState('');
    const [search, setSearch] = useState('');

    const initialForm = { full_name: "", email: "", role: "User", status: "Active" };
    const [form, setForm] = useState(initialForm);
    const [editForm, setEditForm] = useState(initialForm);

    useEffect(() => {
        const getData = async () => {
            const { data } = await supabase.from('users').select('id, full_name, email, status, role');
            setData(data);
            setLoading(false);
        };
        getData();
    }, []);

    const openEditModal = (item) => {
        setEditItem(item);
        setEditForm(item);
        setEditModalOpen(true);
    };

    const updateUser = async (e) => {
        e.preventDefault();
        const updatePayload = {
            full_name: editForm.full_name,
            email: editForm.email,
            role: editForm.role,
            status: editForm.status
        };
        const { error } = await supabase.from('users').update(updatePayload).eq('id', editItem.id);
        if (!error) {
            setData(prev => prev.map(item => item.id === editItem.id ? { ...item, ...updatePayload } : item));
            setEditModalOpen(false);
        }
    };

    const createUser = async (e) => {
        e.preventDefault();
        const { data: inserted, error } = await supabase.from('users').insert([form]).select();
        if (!error && inserted) {
            setData(prev => [...prev, inserted[0]]);
            setModalOpen(false);
            setForm(initialForm);
        }
    };

    const handleDelete = async (id) => {
        await supabase.from('users').delete().eq('id', id);
        setData(prev => prev.filter(item => item.id !== id));
    };

    const filtered = data.filter(item => {
        const matchRole = filterRole === '' || item.role === filterRole;
        const matchStatus = filterStatus === '' || item.status === filterStatus;
        const matchSearch = search === '' || item.full_name?.toLowerCase().includes(search.toLowerCase()) || item.email?.toLowerCase().includes(search.toLowerCase());
        return matchRole && matchStatus && matchSearch;
    });

    return (
        <>
                    <Preloader />

            {modalOpen && (
                <div className="us-overlay">
                    <div className="us-modal">
                        <div className="us-modal-header">
                            <h2 className="us-modal-title">Add New User</h2>
                            <svg className="us-modal-close" onClick={() => setModalOpen(false)} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                            </svg>
                        </div>
                        <div className="us-modal-body">
                            <form className="us-form" onSubmit={createUser}>
                                <div className="us-form-row">
                                    <div className="us-form-field">
                                        <label className="us-form-label">Full Name</label>
                                        <input required type="text" className="us-form-input" value={form.full_name} onChange={(e) => setForm({...form, full_name: e.target.value})} />
                                    </div>
                                    <div className="us-form-field">
                                        <label className="us-form-label">Email Address</label>
                                        <input required type="email" className="us-form-input" value={form.email} onChange={(e) => setForm({...form, email: e.target.value})} />
                                    </div>
                                </div>
                                <div className="us-form-row">
                                    <div className="us-form-field">
                                        <label className="us-form-label">Role</label>
                                        <select required className="us-form-select" value={form.role} onChange={(e) => setForm({...form, role: e.target.value})}>
                                            <option value="User">User</option>
                                            <option value="Admin">Admin</option>
                                        </select>
                                    </div>
                                    <div className="us-form-field">
                                        <label className="us-form-label">Account Status</label>
                                        <select required className="us-form-select" value={form.status} onChange={(e) => setForm({...form, status: e.target.value})}>
                                            <option value="Active">Active</option>
                                            <option value="Inactive">Inactive</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="us-form-footer">
                                    <button type="button" className="us-cancel-btn" onClick={() => setModalOpen(false)}>Cancel</button>
                                    <button type="submit" className="us-save-btn">
                                        <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M17 3H7L3 7v10a1 1 0 001 1h13a1 1 0 001-1V4a1 1 0 00-1-1zM7 3v5h7V3M7 13h6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                        </svg>
                                        Save User
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}

            {editModalOpen && (
                <div className="us-overlay">
                    <div className="us-modal">
                        <div className="us-modal-header">
                            <h2 className="us-modal-title">Edit User</h2>
                            <svg className="us-modal-close" onClick={() => setEditModalOpen(false)} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                            </svg>
                        </div>
                        <div className="us-modal-body">
                            <form className="us-form" onSubmit={updateUser}>
                                <div className="us-form-row">
                                    <div className="us-form-field">
                                        <label className="us-form-label">Full Name</label>
                                        <input required type="text" className="us-form-input" value={editForm.full_name} onChange={(e) => setEditForm({...editForm, full_name: e.target.value})} />
                                    </div>
                                    <div className="us-form-field">
                                        <label className="us-form-label">Email Address</label>
                                        <input required type="email" className="us-form-input" value={editForm.email} onChange={(e) => setEditForm({...editForm, email: e.target.value})} />
                                    </div>
                                </div>
                                <div className="us-form-row">
                                    <div className="us-form-field">
                                        <label className="us-form-label">Role</label>
                                        <select required className="us-form-select" value={editForm.role} onChange={(e) => setEditForm({...editForm, role: e.target.value})}>
                                            <option value="User">User</option>
                                            <option value="Admin">Admin</option>
                                        </select>
                                    </div>
                                    <div className="us-form-field">
                                        <label className="us-form-label">Account Status</label>
                                        <select required className="us-form-select" value={editForm.status} onChange={(e) => setEditForm({...editForm, status: e.target.value})}>
                                            <option value="Active">Active</option>
                                            <option value="Inactive">Inactive</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="us-form-footer">
                                    <button type="button" className="us-cancel-btn" onClick={() => setEditModalOpen(false)}>Cancel</button>
                                    <button type="submit" className="us-save-btn">
                                        <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M17 3H7L3 7v10a1 1 0 001 1h13a1 1 0 001-1V4a1 1 0 00-1-1zM7 3v5h7V3M7 13h6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                        </svg>
                                        Update User
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}

            <DashLayout title="Users OverView" active="users">
                <div className="us-top">
                    <div className="us-top-left">
                        <h1 className="us-title">Users Management</h1>
                        <p className="us-sub">Manage platform users and permissions</p>
                    </div>
                    <button className="us-add-btn" onClick={() => setModalOpen(true)}>
                        <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M10 4v12M4 10h12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                        </svg>
                        Add New User
                    </button>
                </div>

                <div className="us-stats">
                    <div className="us-stat-card">
                        <p className="us-stat-label">Total Users</p>
                        <p className="us-stat-value">{data.length}</p>
                    </div>
                    <div className="us-stat-card">
                        <p className="us-stat-label">Admins</p>
                        <p className="us-stat-value us-stat-value--purple">{data.filter(item => item.role === 'Admin').length}</p>
                    </div>
                    <div className="us-stat-card">
                        <p className="us-stat-label">User</p>
                        <p className="us-stat-value us-stat-value--blue">{data.filter(item => item.role === 'User').length}</p>
                    </div>
                    <div className="us-stat-card">
                        <p className="us-stat-label">Active</p>
                        <p className="us-stat-value us-stat-value--green">{data.filter(item => item.status === 'Active').length}</p>
                    </div>
                    <div className="us-stat-card">
                        <p className="us-stat-label">Inactive</p>
                        <p className="us-stat-value us-stat-value--gray">{data.filter(item => item.status === 'Inactive').length}</p>
                    </div>
                </div>

                <div className="us-filters">
                    <div className="us-search-wrap">
                        <svg className="us-search-icon" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="9" cy="9" r="5.5" stroke="currentColor" strokeWidth="1.5"/>
                            <path d="M13 13l3 3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                        </svg>
                        <input type="text" className="us-search" placeholder="Search by name, email..." value={search} onChange={e => setSearch(e.target.value)} />
                    </div>
                    <select className="us-select" value={filterRole} onChange={e => setFilterRole(e.target.value)}>
                        <option value="">All Roles</option>
                        <option value="Admin">Admin</option>
                        <option value="User">User</option>
                    </select>
                    <select className="us-select" value={filterStatus} onChange={e => setFilterStatus(e.target.value)}>
                        <option value="">All Status</option>
                        <option value="Active">Active</option>
                        <option value="Inactive">Inactive</option>
                    </select>
                </div>

                <div className="us-table-wrap">
                    {loading ? (
                        <p className='loading'>Loading...</p>
                    ) : (
                        <table className="us-table">
                            <thead>
                                <tr>
                                    <th>Full Name</th>
                                    <th>Email</th>
                                    <th>Role</th>
                                    <th>Status</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filtered.map((item) => (
                                    <tr key={item.id}>
                                        <td className="us-user-name">{item.full_name}</td>
                                        <td className="us-email">{item.email}</td>
                                        <td>
                                            <span className={`us-role us-role--${item.role.toLowerCase()}`}>{item.role}</span>
                                        </td>
                                        <td>
                                            <span className={`us-status us-status--${item.status.toLowerCase()}`}>{item.status}</span>
                                        </td>
                                        <td>
                                            <div className="us-actions">
                                                <button className="us-action-btn us-action-btn--edit" onClick={() => openEditModal(item)}>
                                                    <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M14.5 2.5a2.121 2.121 0 013 3L6 17H3v-3L14.5 2.5z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/>
                                                    </svg>
                                                </button>
                                                <button className="us-action-btn us-action-btn--delete" onClick={() => handleDelete(item.id)}>
                                                    <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M3 5h14M8 5V3h4v2M6 5l1 11h6l1-11" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                                    </svg>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}
                </div>
            </DashLayout>
        </>
    );
};

export default Users;